import { render, staticRenderFns } from "./AssessmentCcmSummaryPanel.vue?vue&type=template&id=288202aa&scoped=true&"
import script from "./AssessmentCcmSummaryPanel.vue?vue&type=script&lang=js&"
export * from "./AssessmentCcmSummaryPanel.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentCcmSummaryPanel.vue?vue&type=style&index=0&id=288202aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288202aa",
  null
  
)

export default component.exports